import api from '@/api';

export const actions = {

    societyMatchesStoreRequest({dispatch}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({url: 'requests', data:data, method: 'POST'})
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },

    societyMatchesAddTicketRequest({dispatch, commit}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({url: 'requests/' + data.id + '/add-contacts', data:data, method: 'PUT'})
                .then(resp => {
                    commit('storeCurrentSocietyRequest', resp.data);
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },

    societyMatchesRemoveTicketFromRequest({dispatch, commit}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({url: 'requests/' + data.id + '/remove-contact/' + data.idContact, method: 'DELETE'})
                .then(resp => {
                    commit('storeCurrentSocietyRequest', resp.data);
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },

    societyMatchesShowRequest({commit, dispatch}, data) {

        return new Promise((resolve, reject) => {

            dispatch('commonStartLoading');
            api({url: 'requests/' + data.id, method: 'GET'})
                .then(resp => {
                    commit('storeCurrentSocietyRequest', resp.data);
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },

    societyMatchesGetRequestsByStatus({commit, dispatch}, data) {

        return new Promise((resolve, reject) => {

            dispatch('commonStartLoading');
            api({url: 'requests/statuses', method: 'GET', params: {statuses : data},})
                .then(resp => {
                    commit('storeCurrentSocietyRequest', resp.data);
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },

    societyMatchesGetSectorAvailability({dispatch}, data) {

        return new Promise((resolve, reject) => {

            dispatch('commonStartLoading');
            let path = 'matches/' + data.idMatch + '/busy-sector-seats';
            if(data.idSector) {
                path += '/' + data.idSector;
            }
            api({url: path, method: 'GET'})
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },

    societyMatchesGetContactAvailability({dispatch}, data) {

        return new Promise((resolve, reject) => {

            dispatch('commonStartLoading');
            api({
                url: 'matches/' + data.idMatch + '/contacts-availability',
                params: {mode : data.mode},
                method: 'GET'})
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },

    societyMatchesGetPaymentUrl({dispatch}, data) {

        return new Promise((resolve, reject) => {

            dispatch('commonStartLoading');
            api({
                url: 'payments/url-payment',
                data : {
                    id: data.id,
                    back_url: process.env.VUE_APP_BASE_URL + '/society/payment/handle'
                },
                method: 'POST'})
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },

    societyMatchesHandlePaymentResponse({dispatch}, data) {

        return new Promise((resolve, reject) => {

            dispatch('commonStartLoading');
            api({
                url: 'payments/handle-payment',
                data : data,
                method: 'POST'})
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },

    societyMatchesDeleteRequest({dispatch}, data) {

        return new Promise((resolve, reject) => {

            dispatch('commonStartLoading');
            api({
                url: 'requests/' + data.id,
                method: 'DELETE'})
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },

    societyMatchesRequestAlreadyPaid({dispatch}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({
                url: 'requests/' + data.id + '/already-paid-request',
                method: 'POST',
                data: data})
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },

}
